import { PrizmLanguageKit } from '../../interfaces';

export const PRIZM_ENGLISH_LANGUAGE_KIT: PrizmLanguageKit = {
  cancel: 'Cancel',
  done: 'Done',
  emptyListText: `Nothing found`,
  more: 'More',
  otherDate: 'Other date',
  showAll: 'Show all',
  hide: 'Hide',
  mobileCalendarTexts: ['Select day', 'Select period'],
  range: ['from', 'to'],
  countTexts: ['Plus', 'Minus'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd',
  },
  digitalInformationUnits: ['B', 'KB', 'MB'],
  passwordTexts: ['Show password', 'Hide password'],
  copyTexts: ['Copy', 'Copied'],
  shortCalendarMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  pagination: ['Previous page', 'Next page'],
  fileTexts: {
    loadingError: 'Loading error',
    preview: 'Preview',
    remove: 'Remove',
  },
  inputFileTexts: {
    defaultLabelSingle: 'or drag it here',
    defaultLabelMultiple: 'or drag them here',
    defaultLinkSingle: 'Select a file',
    defaultLinkMultiple: 'Select files',
    maxSizeRejectionReason: 'File exceeds size limit ',
    formatRejectionReason: 'Invalid file format',
    drop: 'Drop file here',
    dropMultiple: 'Drop files here',
  },
  search: `Search`,
};
